
export enum RequestStatus{

    None,
    New,
    Scheduled,
    Error,
    Done,
    UnProcessable
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Reports/model/RequestStatus.ts